import { render, staticRenderFns } from "./ActivatePage.vue?vue&type=template&id=0f70510e"
import script from "./ActivatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivatePage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f70510e')) {
      api.createRecord('0f70510e', component.options)
    } else {
      api.reload('0f70510e', component.options)
    }
    module.hot.accept("./ActivatePage.vue?vue&type=template&id=0f70510e", function () {
      api.rerender('0f70510e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/account/activate/ActivatePage.vue"
export default component.exports